import qrcode from "qrcode-generator";

/**
 * The form URL as a boolean matrix, encoded locally.
 *
 * Deliberately not a QR image service: the form URL is the one thing on the
 * share screen worth not handing to a third party, and an image endpoint sees
 * every slug it renders. `qrcode-generator` is ~10 kB and dependency-free, so
 * this costs less than the request it replaces.
 *
 * Type 0 auto-sizes to the shortest version that fits. Error correction "M"
 * survives a phone camera at an angle without inflating the module count.
 * Returns null rather than throwing when the text simply will not fit.
 */
export const qrMatrix = (text: string): boolean[][] | null => {
  try {
    const qr = qrcode(0, "M");
    qr.addData(text);
    qr.make();
    const n = qr.getModuleCount();
    return Array.from({ length: n }, (_, row) =>
      Array.from({ length: n }, (_, col) => qr.isDark(row, col)),
    );
  } catch {
    return null;
  }
};
